module.exports = __webpack_public_path__ + "img/millfields_rd_b5.56a1dfe2.jpg";